module.exports = __webpack_public_path__ + "src/assets/vehicles/bike-jump.svg";